/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { SyncLoader } from "react-spinners";
import { hitApi } from "../utils/apiCall";

function StudentExamDetails() {
  const { id, seid } = useParams();
  const [fetchedBasicData, setFetchedBasicData] = useState({});

  const navgate = useNavigate();
  const [theme] = useState(localStorage.getItem("theme"));
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(false); // 🔸 Add loading state

  useEffect(() => {
    async function fetchBasicDetails(stdId, enrId) {
      const fd = new FormData();
      fd.append("studentId", stdId);
      fd.append("enrollId", enrId);
      const res = await hitApi(
        "admission/createAddmissionMain",
        "getStudentDetailsAllInfo",
        fd
      );
      if (res.success) {
        setFetchedBasicData(res.data[0]);
      } else {
        setFetchedBasicData(res.data[0]);
      }
    }
    fetchBasicDetails(id, seid);
  }, [id, seid]);

  const dateFormatter = (date) => {
    return date?.split("-")?.reverse().join("-");
  };

  const getDisplayName = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };

  useEffect(() => {
    async function getExamDetails() {
      const token = localStorage.getItem("token");
      const fd = new FormData();
      fd.append("authToken", localStorage.getItem("authToken"));
      fd.append("programType", "getStudentExamDetailsForParent");
      fd.append("sectionId", fetchedBasicData?.section_id);
      fd.append("classId", fetchedBasicData?.class_id);
      fd.append("studentId", id);

      setLoading(true); // 🔸 Start loader

      try {
        const res = await hitApi(
          "/exam_master/exam",
          "getStudentExamDetailsForParent",
          fd
        );

        console.log(res)
        if (res.success) {
          setData(res.data || []);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching exam details:", error);
        setData([]);
      } finally {
        setLoading(false); // 🔸 Stop loader
      }
    }

    getExamDetails();
  }, [fetchedBasicData, id]);

  return (
    <div className="page-content-wrapper mt-0">
      {loading && (
        <div className="text-center my-4">
          <SyncLoader
            color="orange"
            loading={loading}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
            size={8}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}

      {/* Results  */}
      {!loading && (
        <div
          className="container p-2 scroll-y-auto"
          style={{ marginTop: "0rem" }}
        >
          {data?.length > 0 ? (
            data?.map((exam, index) => {
              const marksData = JSON.parse(exam.sub_and_marks);
              return (
                <div key={index} className="card px-2 mb-4">
                  <div className="card-header p-0 py-2 bg-white  d-flex justify-content-between">
                    <div className="text-center dar" style={{ margin: "8px" }}>
                      {exam.name}
                    </div>
                    <div className="text-center dar" style={{ margin: "8px" }}>
                      <i className="bi bi-calendar  me-2"></i>
                      {dateFormatter(exam.startDate)}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered border-dark">
                      <thead
                        className={
                          "table-primary"
                          // exam.examStatus?.toLowerCase() === "pass"
                          //   ? "table-success"
                          //   : "table-danger"
                        }
                      >
                        <tr>
                          <th>Subject</th>
                          <th>Min</th>
                          <th>Max</th>
                          <th>Obtained</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marksData?.map((mark, i) => (
                          <tr key={i}>
                            <td className="fw-bold">{mark.subjectName}</td>
                            <td>{mark.minMarks}</td>
                            <td>{mark.marks}</td>
                            <td>{mark.obtainedMarks}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr className="fw-bold">
                          <td colSpan="3" className="text-end fw-bold">
                            Total
                          </td>
                          <td colSpan="2">
                            {exam.obtainedMarks}
                          </td>
                        </tr>
                        {/* <tr className="fw-bold">
                          <td colSpan="3" className="text-end fw-bold">
                            Final Result
                          </td>
                          <td
                            colSpan="2"
                            className={
                              exam.examStatus?.toLowerCase() === "pass"
                                ? "text-success fw-bold"
                                : "text-danger fw-bold"
                            }
                          >
                            {exam.examStatus}
                          </td>
                        </tr> */}
                      </tfoot>
                    </table>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ marginTop: "15rem" }}>
              <h6 className="text-center">No exams available at the moment.</h6>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default StudentExamDetails;
